import {H1} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import type {DepartmentNode} from '../types'

import {KilnSwitch} from './KilnSwitch'

interface PageHeaderWithSwitchProps {
  kilnNodes: DepartmentNode[]
  titleKey: string
}

export const PageHeaderWithSwitch: React.FC<PageHeaderWithSwitchProps> = ({
  kilnNodes,
  titleKey
}) => {
  const {t} = useTranslation()

  return (
    <div className="flex justify-between items-center">
      <H1 className="my-6 ml-6 max-w-400px">{t(titleKey)}</H1>
      <div className="my-6 ml-6">
        <KilnSwitch kilnNodes={kilnNodes} />
      </div>
    </div>
  )
}
